<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header w-f3">
        <div class="with-desc">
            <h2>Mark {{data.module | titlecase}} Complete</h2>
        </div>

        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="onCancelClick()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body -->
    <div class="flx-modal__body skim gap-3">
        <form [formGroup]="markCompleteForm">
            <div>
                <div class="status-field">
                    <label class="field-title-two">Recording completion for <span class="font-semiBold">{{data?.assetCertificationTypeName}}&nbsp;({{data?.runningNo}})</span></label>
                </div>

                <!-- Completion Date -->
                <div class="status-field">
                    <label class="field-label mandatory">Completion Date</label>
                    <div class="field-row field-row--auto">
                        <p-calendar selectionMode="single" dateFormat="dd/mm/yy" yearRange="2000:2030" type="text"
                            formControlName="completeDate" styleClass="cal-btn" [maxDate]="todaydate"
                            [yearNavigator]="true" appendTo="body"  [showIcon]="true" placeholder="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="p-error text-10" *ngIf="(markCompleteForm.controls['completeDate'].touched || markCompleteForm.controls['completeDate'].dirty) && markCompleteForm.controls['completeDate'].invalid">
                        <span *ngIf="markCompleteForm.controls['completeDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
                <!-- Performed By -->
                <div class="status-field">
                    <label class="field-label mandatory">Performed By</label>
                    <div class="field-row field-row--auto gap-0 flex-align-center">
                             <span class="p-input-icon-right w-100">
                                <p-autoComplete (onBlur)="onvalidUser()" styleClass="w-100"
                                    [placeholder]="'Select a user who performed this '+data.module" [ngClass]="{'ng-invalid ng-dirty': (markCompleteForm.controls['performedBy'].touched || markCompleteForm.controls['performedBy'].dirty ) && markCompleteForm.controls['performedBy'].invalid}"
                                    (onSelect)="gotSelectedUser($event)" field="fullName" [suggestions]="users"
                                    (completeMethod)="getUsers($event)" name="performedBy" id="picklist_UserQBNameField"
                                    formControlName="performedBy" (onClear)="clearValue1('user')"
                                    (keyup)="onUserInputChange($event)" id="picklist_Userlist">
                                </p-autoComplete>
                                <i *ngIf="markCompleteForm.controls['performedBy'].value"
                                    class="p-autocomplete-clear-icon pi pi-times" (click)="clearValue1('user')"></i>
                            </span>

                            <button type="button" [pTooltip]="'User Lookup'" tooltipPosition="left" pButton
                                icon="fa-regular fa-magnifying-glass" (click)="showTable1('userTable')"></button>
                    </div>
                    <div class="p-error text-10" *ngIf="(markCompleteForm.controls['performedBy'].touched || markCompleteForm.controls['performedBy'].dirty) && markCompleteForm.controls['performedBy'].invalid">
                        <span *ngIf="markCompleteForm.controls['performedBy'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        <!-- <span *ngIf="markCompleteForm.controls['performedBy'].errors?.pattern">Only letters and numbers are allowed</span> -->
                    </div>
                </div>
                <!-- Result -->
                <div class="status-field">
                    <label class="field-label mandatory">Result</label>
                    <div class="field-row field-row--auto">
                        <p-dropdown [placeholder]="'Select a result'" [options]="resultOptions" 
                            formControlName="result"
                            optionLabel="name" optionValue="value" >
                        </p-dropdown>
                    </div>
                    <div class="p-error text-10" *ngIf="(markCompleteForm.controls['result'].touched || markCompleteForm.controls['result'].dirty) && markCompleteForm.controls['result'].invalid">
                        <span *ngIf="markCompleteForm.controls['result'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
                <!-- Remarks -->
                <div class="status-field">
                    <label class="field-label">Remarks</label>
                    <div class="field-row field-row--auto">
                        <textarea type="text" class="w-100" formControlName="remark" pInputTextarea autocomplete="off"
                            placeholder="Enter your remarks on this certification here"></textarea>
                    </div>
                    <div class="p-error text-10" *ngIf="(markCompleteForm.controls['remark'].touched || markCompleteForm.controls['remark'].dirty) && markCompleteForm.controls['remark'].invalid">
                        <span *ngIf="markCompleteForm.controls['remark'].errors?.maxlength">{{'Characters length exceeds 255.'}}</span>
                    </div>
                </div>
                <!-- Certificate/Report -->
                <div class="status-field" *ngIf="data.module== 'certification'">
                    <label class="field-label">Certificate/Report</label>
                    <div class="field-row field-row--auto">
                        <p-fileUpload #fileUpload [chooseLabel]="translate?.general.buttons.uploadFile.singular"
                            [chooseIcon]="'pi pi-upload'" [customUpload]="true" [auto]="true" 
                            [invalidFileSizeMessageDetail]="translate?.attachments.messages.allowedFileSize" 
                            (uploadHandler)="uploadFile($event, fileUpload)" (onError)="handleUploadError($event)"
                            [maxFileSize]="25000000" [invalidFileSizeMessageSummary]="translate?.attachments.messages.invalidFileSize" >
                            <ng-template pTemplate="content">
                                <div>
                                    <div class="p-fileupload-files custella-files">
                                        <div class="p-fileupload-row" *ngFor="let attach of attachments; index as i;">
                                            <div class="custella-file-notification flex-between rounded-2 w-100">
                                                <!-- <img [src]="file.attachmentUrl" class="w-24px"> -->
                                                <div class="d-flex align-items-center">
                                                    <i class="pi pi-file"></i>
                                                    <span class="custella-content-row-input-title ms-2 pt-1 cursor-pointer text-12">{{attach.name}}</span>
                                                </div>
                                                <span class="custella-file-notification-remove color-primary text-12 cursor-pointer" (click)="onFileRemove(attach, i)">{{translate?.general.buttons.remove.singular}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="attachments.length === 0">
                                    <i class="fa-regular fa-folder-arrow-up pe-none"></i>
                                    <span class="text-12 font-medium fst-italic ms-2">{{translate?.general.messages.dragAndDropFileToUpload}}</span>
                                </div>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="onCancelClick()">
            {{ translate?.general.buttons.cancel.singular }}
        </button>
        <p-button styleClass="h-32" type="button" [label]="translate?.general.buttons.save.singular" (onClick)="onClickSave()"></p-button>
    </div>
</div>

<footer *ngIf="displayUserTable" class="custella-form-container-footer hidePopup">
    <p-dialog [header]="'User Details'" id="title_UserDet" [(visible)]="displayUserTable"
        showEffect="fade" [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
        <app-custella-users (itemSelector)="gotSelectedUser($event)" (closeView)="closeUserView('user')"></app-custella-users>
    </p-dialog>
</footer>